module.exports = __webpack_public_path__ + "img/container.e3101435.svg";